import React from 'react';
import { Message } from 'flow/types/Chats';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';
import ChatPostDisplay, { pathnameIsOverview } from './ChatPostDisplay';
import ChatPostFooter from './ChatPostFooter';
import { useLocation } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface Props {
    message: TypedMap<Message>;
    sessionKey: ChatSessionKey;
    hideLikesAndComments?: boolean;
}

const ChatPostSummary = ({ message, sessionKey }: Props) => {
    const { pathname } = useLocation();

    const inOverview = pathnameIsOverview(pathname);

    return (
        <div className={twMerge('w-full', !inOverview && 'p-4')}>
            <div className="rounded-sm bg-white shadow-lg dark:bg-gray-100">
                <ChatPostDisplay
                    message={message}
                    sessionKey={sessionKey}
                    isSummary={true}
                    inOverview={inOverview}
                />
                <ChatPostFooter
                    message={message}
                    sessionKey={sessionKey}
                    navigateOnClick={true}
                />
            </div>
        </div>
    );
};

export default ChatPostSummary;
